import { AppNames } from '../appNames.model';

export const SUPPORT_CONTACT_PATH = `/${AppNames.SUPPORT}/contact`;
export const SUPPORT_FAQS_PATH = `/${AppNames.SUPPORT}/faqs`;
